 import React from 'react'
import {Link} from 'react-router-dom'
import PropTypes from 'prop-types'

import UslugaCard from '../UslugaCard'

import './popular-services.sass'
import Arrow from "../Arrow"

 const PopularServices = ({servant_passports, linkOptions}) => {
   if (!linkOptions && !servant_passports){
     return null
   }
   return (
     <div className="popular-services">
       {servant_passports.map((passport) => (
         <UslugaCard key={passport.id} passport={passport} linkOptions={linkOptions} path="" >
           {linkOptions.map((linkOption) => (
             <Link key={linkOption.key} className="usluga-card__link" to={linkOption.path(passport.id)}>{linkOption.name}<Arrow /></Link>
           ))}
         </UslugaCard>
       ))}
     </div>
   )
 }

 {/* eslint-disable */}
 PopularServices.propTypes = {
   linkOptions: PropTypes.array.isRequired,
   servant_passports: PropTypes.array.isRequired
 }
 {/* eslint-disable */}

 export default PopularServices



// WEBPACK FOOTER //
// ./components/PopularServices/index.jsx